
const ShopToolbar = () => {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">
          All Products
        </h2>

        <p className="text-gray-500 mt-1">
          Browse our healthcare equipment collection.
        </p>
      </div>

    </div>
  );
};

export default ShopToolbar;